Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.LateArrival = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'LateArrivalEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'arrivalTypeContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'delayTimeContainer'
            }
          },
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const arrivalType = new Monet.UI.Fields.Render({
      name: 'arrivalType',
      label: 'event.lateArrival.arrivalType',
      mandatory: false,
      type: 'CHECKBOX_GROUP',
      fieldDomains: [
        { description: 'event.lateArrival.arrivalType.firstStop', value: 'firstStop', id: 'firstStop' },
        { description: 'event.lateArrival.arrivalType.anyStop', value: 'anyStop', id: 'anyStop' },
        { description: 'event.lateArrival.arrivalType.destination', value: 'destination', id: 'destination' }
      ]
    }, 'Event').render();

    const delayTime = new Monet.UI.Fields.Render({
      name: 'delayTime',
      label: 'event.lateArrival.delayTime',
      mandatory: false,
      type: 'INTEGER',
      defaultValue: '0',
    }).render();

    Greenmile.Checks.EventCheck.LateArrival.fields = { arrivalType, delayTime };

    //Append fields to DOM  
    const arrivalTypeContainer = document.querySelector('#LateArrivalEvent #arrivalTypeContainer');
    arrivalTypeContainer.appendChild(arrivalType.rootEl);

    const delayTimeContainer = document.querySelector('#LateArrivalEvent #delayTimeContainer');
    delayTimeContainer.appendChild(delayTime.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.LateArrival.renderFields();
    const fields = Greenmile.Checks.EventCheck.LateArrival.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.arrivalType.setValue(jsonParam.typeArrival);
      fields.delayTime.setValue(jsonParam.delayTime);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.LateArrival.fields;
    return JSON.stringify({
      typeArrival: fields.arrivalType.getValue(),
      delayTime: fields.delayTime.getValue()
    });
  }

};